import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Droplets, Clock, Home as HomeIcon, CheckCircle, MapPin, Star, Phone } from 'lucide-react';
import { TrustBar } from '../components/TrustBar';
import { ServiceCard } from '../components/ServiceCard';
import { BeforeAfterSlider } from '../components/BeforeAfterSlider';
import { CTABanner } from '../components/CTABanner';
export function Home() {
  return <div className="w-full" data-id="element-396">
      {/* 1. Video Hero Header */}
      <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden" data-id="element-397">
        {/* Fallback background image (shows while video loads or if it fails) */}
        <div className="absolute inset-0 bg-cover bg-center z-0" style={{
        backgroundImage: 'url("https://images.unsplash.com/photo-1625766763788-95dcce9bf5ac?ixlib=rb-4.0.3&auto=format&fit=crop&w=2071&q=80")'
      }} data-id="element-398"></div>

        {/* Video Background — pressure washing exterior */}
        <video autoPlay muted loop playsInline className="absolute inset-0 w-full h-full object-cover z-0" data-id="element-399">
          <source src="https://cdn.magicpatterns.com/uploads/diBgE4VrUi92699QGew8Zr/softwash pros Macomb and Oakland County.mp4" type="video/mp4" data-id="element-400" />
        </video>

        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-navy/70 z-10" data-id="element-401"></div>

        {/* Hero Content */}
        <div className="relative z-20 text-center px-4 max-w-5xl mx-auto mt-16 flex flex-col items-center" data-id="element-402">
          <img src="https://cdn.magicpatterns.com/uploads/5AVKXiTXV1VVA3kGuFBhc2/TheSoftwashPros-logo.jpg" alt="Softwash Pros Logo" className="h-24 md:h-32 mb-6 rounded-2xl shadow-2xl" data-id="element-403" />
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-montserrat font-black text-white mb-6 leading-tight text-shadow-lg" data-id="element-404">
            We Clean It So You Don't Have To!
          </h1>
          <p className="text-xl md:text-2xl text-cream mb-10 max-w-3xl mx-auto font-medium text-shadow" data-id="element-405">
            Safe, eco-friendly, and longer-lasting alternative to pressure
            washing. We restore your property's beauty without the damage.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-406">
            <Link to="/contact" className="w-full sm:w-auto bg-light-blue text-dark font-bold py-4 px-8 rounded-md hover:bg-white transition-colors text-lg shadow-lg" data-id="element-407">
              Get a Free Quote
            </Link>
            <Link to="/services" className="w-full sm:w-auto bg-transparent border-2 border-white text-white font-bold py-4 px-8 rounded-md hover:bg-white hover:text-navy transition-colors text-lg" data-id="element-408">
              Our Services
            </Link>
          </div>

          <div className="mt-8 flex items-center justify-center text-white text-xl font-bold" data-id="element-409">
            <Phone className="w-6 h-6 mr-2 text-light-blue" data-id="element-410" />
            <a href="tel:586-298-2727" className="hover:text-light-blue transition-colors" data-id="element-411">
              586-298-2727
            </a>
          </div>
        </div>
      </section>

      {/* 2. Trust Bar */}
      <TrustBar data-id="element-412" />

      {/* 3. Services Overview */}
      <section className="py-20 bg-gray-50" data-id="element-413">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-414">
          <div className="text-center mb-16" data-id="element-415">
            <h2 className="text-3xl md:text-4xl font-montserrat text-navy mb-4" data-id="element-416">
              Our Exterior Cleaning Services
            </h2>
            <div className="w-24 h-1 bg-light-blue mx-auto mb-6" data-id="element-417"></div>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-418">
              We use specialized soft washing techniques tailored to each
              surface, ensuring a deep clean without the risk of high-pressure
              damage.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-419">
            <ServiceCard title="Residential Soft Washing" description="Complete exterior house washing safe for siding, stucco, and brick." icon={HomeIcon} linkTo="/services/residential" data-id="element-420" />
            <ServiceCard title="Roof Cleaning" description="Remove black streaks, moss, and algae safely to extend your roof's lifespan." icon={HomeIcon} linkTo="/services/roof" data-id="element-421" />
            <ServiceCard title="Gutter Cleaning" description="Inside and out gutter cleaning to ensure proper flow and a bright appearance." icon={Droplets} linkTo="/services/gutter" data-id="element-422" />
            <ServiceCard title="Driveway & Concrete" description="Restore concrete surfaces, removing dirt, oil, and organic growth." icon={HomeIcon} linkTo="/services/driveway" data-id="element-423" />
            <ServiceCard title="Deck & Patio" description="Safe cleaning for wood, composite, and stone outdoor living spaces." icon={HomeIcon} linkTo="/services/deck" data-id="element-424" />
            <ServiceCard title="Fence Cleaning" description="Revitalize wood and vinyl fences, removing graying and mildew." icon={HomeIcon} linkTo="/services/fence" data-id="element-425" />
            <ServiceCard title="Commercial Services" description="Keep your business looking professional and inviting for customers." icon={HomeIcon} linkTo="/commercial" data-id="element-426" />
            <div className="bg-navy rounded-xl p-8 shadow-soft flex flex-col items-center justify-center text-center h-full border border-navy" data-id="element-427">
              <h3 className="text-2xl font-montserrat text-white mb-4" data-id="element-428">
                Need a Custom Quote?
              </h3>
              <p className="text-cream mb-6" data-id="element-429">
                We handle properties of all sizes.
              </p>
              <Link to="/contact" className="bg-light-blue text-dark font-bold py-3 px-6 rounded hover:bg-white transition-colors w-full" data-id="element-430">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 4. Before & After Slider Section */}
      <section className="py-20 bg-white" data-id="element-431">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-432">
          <div className="text-center mb-16" data-id="element-433">
            <h2 className="text-3xl md:text-4xl font-montserrat text-navy mb-4" data-id="element-434">
              See the Difference
            </h2>
            <div className="w-24 h-1 bg-light-blue mx-auto mb-6" data-id="element-435"></div>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-436">
              Drag the slider to see the instant restoration our soft washing
              process provides.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-437">
            <BeforeAfterSlider label="Roof Cleaning" beforeImage="https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=1000&q=80" afterImage="https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=1000&q=80" data-id="element-438" />
            <BeforeAfterSlider label="Driveway Cleaning" beforeImage="https://images.unsplash.com/photo-1625766763788-95dcce9bf5ac?w=1000&q=80" afterImage="https://images.unsplash.com/photo-1558036117-15d82a90b9b1?w=1000&q=80" data-id="element-439" />
            <BeforeAfterSlider label="House Siding" beforeImage="https://images.unsplash.com/photo-1605146769289-440113cc3d00?w=1000&q=80" afterImage="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1000&q=80" data-id="element-440" />
            <BeforeAfterSlider label="Deck Restoration" beforeImage="https://images.unsplash.com/photo-1591825729269-caeb344f6df2?w=1000&q=80" afterImage="https://images.unsplash.com/photo-1505691938895-1758d7feb511?w=1000&q=80" data-id="element-441" />
          </div>

          <div className="text-center mt-12" data-id="element-442">
            <Link to="/gallery" className="inline-flex items-center text-navy font-bold hover:text-light-blue transition-colors text-lg" data-id="element-443">
              View Full Gallery
            </Link>
          </div>
        </div>
      </section>

      {/* 5. Why Choose Softwash Pros */}
      <section className="py-20 bg-cream" data-id="element-444">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-445">
          <div className="text-center mb-16" data-id="element-446">
            <h2 className="text-3xl md:text-4xl font-montserrat text-navy mb-4" data-id="element-447">
              Why Choose Softwash Pros?
            </h2>
            <div className="w-24 h-1 bg-navy mx-auto mb-6" data-id="element-448"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-449">
            {[{
            icon: Shield,
            title: 'Safe for All Surfaces',
            desc: 'Low pressure prevents damage to siding, shingles, and paint.'
          }, {
            icon: Droplets,
            title: 'Eco-Friendly Solutions',
            desc: '100% biodegradable cleaning agents safe for pets and plants.'
          }, {
            icon: Clock,
            title: 'Longer-Lasting Results',
            desc: 'Kills algae and mold at the root, lasting 4-6x longer than pressure washing.'
          }, {
            icon: CheckCircle,
            title: 'No Damage Guarantee',
            desc: 'We never use high pressure on delicate exterior surfaces.'
          }, {
            icon: Shield,
            title: 'Fully Licensed & Insured',
            desc: 'Complete peace of mind while we are working on your property.'
          }, {
            icon: Star,
            title: 'Free, Fast Quotes',
            desc: 'Transparent pricing with no hidden fees or surprises.'
          }].map((item, idx) => <div key={idx} className="bg-white p-8 rounded-xl shadow-sm flex flex-col items-center text-center" data-id="element-450">
                <div className="w-16 h-16 bg-light-blue/10 rounded-full flex items-center justify-center mb-6" data-id="element-451">
                  <item.icon className="w-8 h-8 text-navy" data-id="element-452" />
                </div>
                <h3 className="text-xl font-montserrat text-navy mb-3" data-id="element-453">
                  {item.title}
                </h3>
                <p className="text-gray-600" data-id="element-454">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 6. How It Works */}
      <section className="py-20 bg-white" data-id="element-455">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-456">
          <div className="text-center mb-16" data-id="element-457">
            <h2 className="text-3xl md:text-4xl font-montserrat text-navy mb-4" data-id="element-458">
              How It Works
            </h2>
            <div className="w-24 h-1 bg-light-blue mx-auto mb-6" data-id="element-459"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative" data-id="element-460">
            {/* Connecting Line (Desktop) */}
            <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-1 bg-gray-200 z-0" data-id="element-461"></div>

            {[{
            step: '1',
            title: 'Get a Free Quote',
            desc: "Call or fill out our form. We'll provide a fast, transparent estimate."
          }, {
            step: '2',
            title: 'Scheduled Service',
            desc: 'Our professional team arrives on time with state-of-the-art equipment.'
          }, {
            step: '3',
            title: 'Sparkling Results',
            desc: 'Enjoy a beautifully restored exterior with our satisfaction guarantee.'
          }].map((item, idx) => <div key={idx} className="relative z-10 flex flex-col items-center text-center" data-id="element-462">
                <div className="w-24 h-24 bg-navy text-white rounded-full flex items-center justify-center text-3xl font-montserrat font-bold border-8 border-white shadow-md mb-6" data-id="element-463">
                  {item.step}
                </div>
                <h3 className="text-2xl font-montserrat text-navy mb-3" data-id="element-464">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-lg" data-id="element-465">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 7. Customer Reviews */}
      <section className="py-20 bg-gray-50" data-id="element-466">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-467">
          <div className="text-center mb-16" data-id="element-468">
            <h2 className="text-3xl md:text-4xl font-montserrat text-navy mb-4" data-id="element-469">
              What Our Clients Say
            </h2>
            <div className="w-24 h-1 bg-light-blue mx-auto mb-6" data-id="element-470"></div>
            <div className="flex items-center justify-center space-x-2 text-yellow-400 mb-2" data-id="element-471">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-6 h-6 fill-current" data-id="element-472" />)}
            </div>
            <p className="text-gray-600 font-semibold" data-id="element-473">5.0 Average Rating</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-474">
            {[{
            name: 'Sarah M.',
            text: "Incredible difference! Our roof looks brand new and they didn't use any high pressure that could damage the shingles. Highly recommend Softwash Pros!"
          }, {
            name: 'John D.',
            text: "Professional, on time, and the results speak for themselves. The siding on our house hasn't looked this good since we bought it 10 years ago."
          }, {
            name: 'Michael R.',
            text: 'They cleaned our driveway and patio. The team was respectful of our landscaping and the eco-friendly solutions worked perfectly. Great local company.'
          }].map((review, idx) => <div key={idx} className="bg-white p-8 rounded-xl shadow-soft border border-gray-100 relative" data-id="element-475">
                <div className="text-light-blue opacity-20 absolute top-4 right-6 text-6xl font-serif" data-id="element-476">
                  "
                </div>
                <div className="flex text-yellow-400 mb-4" data-id="element-477">
                  {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-478" />)}
                </div>
                <p className="text-gray-600 mb-6 relative z-10 italic" data-id="element-479">
                  "{review.text}"
                </p>
                <div className="font-montserrat font-bold text-navy" data-id="element-480">
                  - {review.name}
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 8. Service Area */}
      <section className="py-20 bg-white border-t border-gray-100" data-id="element-481">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-482">
          <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-483">
            <div className="lg:w-1/2" data-id="element-484">
              <h2 className="text-3xl md:text-4xl font-montserrat text-navy mb-6" data-id="element-485">
                Proudly Serving the Area
              </h2>
              <p className="text-lg text-gray-600 mb-8" data-id="element-486">
                Softwash Pros provides top-tier exterior cleaning services to
                residential and commercial properties throughout the region.
              </p>
              <div className="grid grid-cols-2 gap-4 mb-8" data-id="element-487">
                {['Macomb County', 'Oakland County', 'Wayne County', 'St. Clair County', 'Shelby Township', 'Sterling Heights', 'Troy', 'Rochester'].map((city, idx) => <div key={idx} className="flex items-center text-gray-700" data-id="element-488">
                    <MapPin className="w-5 h-5 text-light-blue mr-2" data-id="element-489" />
                    {city}
                  </div>)}
              </div>
              <p className="text-navy font-semibold" data-id="element-490">
                Don't see your area? Call us to check availability!
              </p>
            </div>
            <div className="lg:w-1/2 w-full h-[400px] bg-gray-200 rounded-xl overflow-hidden shadow-inner flex items-center justify-center" data-id="element-491">
              {/* Map Placeholder */}
              <div className="text-center text-gray-500" data-id="element-492">
                <MapPin className="w-12 h-12 mx-auto mb-2 opacity-50" data-id="element-493" />
                <p data-id="element-494">Interactive Map Embed Placeholder</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 9. Final CTA Banner */}
      <CTABanner data-id="element-495" />
    </div>;
}